export default {
  CLEAR_SIDENAV_OPENED_CATEGORIES: 'CLEAR_SIDENAV_OPENED_CATEGORIES',
  SET_SIDENAV_OPENED_CATEGORIES: 'SET_SIDENAV_OPENED_CATEGORIES',
};
